import axios from '@/zenky'

export default {
  namespaced: true,

  state: {
    orderStatuses: null,
    loadPromise: null,
  },

  mutations: {
    set(state, orderStatuses) {
      state.orderStatuses = orderStatuses;
    },

    setLoadPromise(state, p) {
      state.loadPromise = p;
    },
  },

  actions: {
    async load({ state, commit }, reload = false) {
      if (!reload && (state.orderStatuses || state.loadPromise)) {
        return;
      }

      const p = (async () => (await axios.get('/order-statuses')).data.data)();
      commit('setLoadPromise', p);

      const orderStatuses = await p;
      commit('set', orderStatuses);

      return orderStatuses;
    },
  },
}
